exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AlertVcDemo h4[data-v-5fa5a0ae]{color:#066}.AlertVcDemo .demoItem[data-v-5fa5a0ae]{padding:10px 0;font-size:18px;border-bottom:1px dotted #999}.AlertVcDemo .demoItem .item[data-v-5fa5a0ae]{margin-bottom:12px}.AlertVcDemo .demoItem .item p[data-v-5fa5a0ae]{margin-top:10px}", ""]);

// exports
